import dayjs from "dayjs";
import PropTypes from "prop-types";
import Input from "shared/components/Input";
import Select from "shared/components/Select";
import Switch from "shared/components/Switch";
import { PROCESSES } from "utils/api/graphql/queries/processes";
import { DATE_FORMAT } from "utils/constants";
import { bindDateInputProps, bindInputProps } from "utils/helpers/input";

const Fields = ({
  formProps,
  values,
  setFieldValue,
  FORM,
  lockStartDate,
  lockProcess,
}) => (
  <div className="grid--1">
    <Input
      label={FORM.NAME}
      placeholder={FORM.NAME}
      required
      {...bindInputProps({ name: "name", values, ...formProps })}
    />
    <Input
      label={FORM.PLATFORM}
      placeholder={FORM.PLATFORM}
      {...bindInputProps({ name: "platform", values, ...formProps })}
    />
    <Select
      type="async"
      showSearch
      node={{
        query: PROCESSES,
        variables: {
          where: {},
          orderBy: [{ name: "ASC" }],
          take: null,
        },
        accessors: {
          root: "processes.data",
          label: "name",
        },
      }}
      placeholder={FORM.PROCESS}
      label={FORM.PROCESS}
      required
      disabled={lockProcess}
      {...bindInputProps({ name: "process.id", values, ...formProps })}
      value={values.process.id || undefined}
      onChange={(id) => setFieldValue("process", { id: id || "" })}
    />
    <Input
      type="date"
      label={FORM.START_DATE}
      format={DATE_FORMAT}
      disabled={lockStartDate}
      disabledDate={
        lockStartDate
          ? undefined
          : (current) => current && dayjs(current).isBefore(dayjs(), "day")
      }
      {...bindDateInputProps({
        name: "startDate",
        values,
        setFieldValue,
        ...formProps,
      })}
    />
    <Input
      type="date"
      label={FORM.END_DATE}
      format={DATE_FORMAT}
      {...bindDateInputProps({
        name: "endDate",
        values,
        setFieldValue,
        ...formProps,
      })}
    />
    <div className="d-flex justify--between align--center gap-16">
      <div className="d-flex flex--column">
        <strong>{FORM.FIXED}</strong>
        <span>{FORM.FIXED_HINT}</span>
      </div>
      <Switch
        aria-label={FORM.FIXED}
        checked={values.fixed}
        onChange={(checked) => setFieldValue("fixed", checked)}
      />
    </div>
  </div>
);

Fields.propTypes = {
  formProps: PropTypes.object.isRequired,
  values: PropTypes.object.isRequired,
  setFieldValue: PropTypes.func.isRequired,
  FORM: PropTypes.object.isRequired,
  lockStartDate: PropTypes.bool,
  lockProcess: PropTypes.bool,
};

Fields.defaultProps = {
  lockStartDate: false,
  lockProcess: false,
};

export default Fields;
